module.exports = __webpack_public_path__ + "assets-cabinet/img/transactions-icon-black.05868735.svg";